<template>
  <div class="wrapper">
    <EditMenu
      :loading="loading"
      :searching="searching"
      :search-result="searchResult"
      :advertiser-list="advertiserList"
      :insertion-order-list="insertionOrderList"
      :system-owner="systemOwner"
      @search="initMenuList($event)"
      @pagination="pagination($event)"
      @searchAdvertiser="searchAdvertiser"
      @searchInsertionOrder="searchInsertionOrder"
      @reload="initMenuList"
    />
  </div>
</template>

<script>
import { accountInitializer } from '@/mixins/accountInitializer'
import { setDrawerTypeAdmin } from '@/mixins/setDrawerTypeAdmin'
import { setToolBarTypeAdmin } from '@/mixins/setToolBarTypeAdmin'
import EditMenu from '@/components/Admin/Menu/EditMenu'
import { getters as accountGetters } from '@/vuex/modules/account/constants'

export default {
  name: 'Menu',
  components: { EditMenu },
  mixins: [accountInitializer, setDrawerTypeAdmin, setToolBarTypeAdmin],
  data() {
    return {
      loading: true,
      searching: false,
    }
  },
  computed: {
    searchResult() {
      return this.$store.getters['menu/searchResult']
    },
    advertiserList() {
      return this.$store.getters['menu/advertiserList']
    },
    insertionOrderList() {
      return this.$store.getters['menu/insertionOrderList']
    },
    systemOwner() {
      return this.$store.getters[accountGetters.systemOwner]
    },
  },
  async created() {
    this.initMenuList({})
  },
  methods: {
    async initMenuList({ keyword, id, pageSize = 100, pageNo = 1 }) {
      this.loading = true
      await this.$store.dispatch('menu/SEARCH', {
        keyword,
        id,
        pageSize,
        pageNo,
      })
      this.loading = false
    },
    pagination(event) {
      this.initMenuList({ keyword: event.keyword, pageNo: event.pageNo })
    },
    async searchAdvertiser(keyword) {
      this.searching = true
      await this.$store.dispatch('menu/SEARCH_ADVERTISER', keyword)
      this.searching = false
    },
    async searchInsertionOrder({ keyword, id }) {
      this.searching = true
      await this.$store.dispatch('menu/SEARCH_INSERTION_ORDER', { keyword, id })
      this.searching = false
    },
  },
}
</script>

<style scoped>
.wrapper {
  width: 100%;
}
</style>
